module.exports = __webpack_public_path__ + "static/media/bat7.3ab4d13f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat7.png
// module id = 475
// module chunks = 0